// モーダルウインドウ用スクリプト
const modalTriggers = document.querySelectorAll('.modal-trigger');
const closeButtons = document.querySelectorAll('.close-button');
const overlays = document.querySelectorAll('.modal-overlay');

// 開く処理
modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
        const targetId = trigger.getAttribute('data-target');
        const targetModal = document.getElementById(targetId);
        if (targetModal) {
            targetModal.style.display = 'flex';
            document.body.classList.add('no-scroll');
        }
    });
});

// 閉じる処理（ボタン & 背景）
const closeModal = (modal) => {
    modal.style.display = 'none';
    document.body.classList.remove('no-scroll');
};

closeButtons.forEach(button => {
    button.addEventListener('click', () => closeModal(button.closest('.modal-overlay')));
});

overlays.forEach(overlay => {
    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeModal(overlay);
    });
});

// スクロールで検索ボタンの表示・非表示
window.addEventListener('scroll', () => {
  const searchBar = document.querySelector('.header__search-bar-wrapper.is-visible');
  
  // 80px以上スクロールしたら非表示用のクラスを追加
  if (window.scrollY > 100) {
    searchBar.classList.add('is-hidden');
  } else {
    // 80px未満に戻ったら再表示
    searchBar.classList.remove('is-hidden');
  }
});